import React, { Suspense } from 'react';
import icon2 from '../../images/icons/icon_user.svg'
import icon5 from '../../images/icons/icon_link.svg'
import icon6 from '../../images/icons/icon_bookmark.svg'
import blogs from '../../api/blogs';
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import './BlogDetails.css'
const BlogSidebar = React.lazy(() => import('../BlogSidebar'));


const BlogSingle = (props) => {

    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const handleCopyLink = (e) => {
        e.preventDefault();
        const link = window.location.href; // Or any specific URL you want to copy
        navigator.clipboard.writeText(link).then(() => {
            alert('Link copied to clipboard!');
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };

    const [isBookmarked, setIsBookmarked] = React.useState(false);

    React.useEffect(() => {
        const bookmarks = JSON.parse(localStorage.getItem('bookmarkedPosts')) || [];
        setIsBookmarked(bookmarks.includes(BlogDetails.slug));
    }, [BlogDetails.slug]);


    const handleBookmark = (e) => {
        e.preventDefault();
        const slug = BlogDetails.slug;

        // Get existing bookmarks from localStorage
        const bookmarks = JSON.parse(localStorage.getItem('bookmarkedPosts')) || [];

        // Check if this slug is already bookmarked
        if (!bookmarks.includes(slug)) {
            bookmarks.push(slug);
            localStorage.setItem('bookmarkedPosts', JSON.stringify(bookmarks));
            alert('Bookmarked!');
        } else {
            alert('Already bookmarked!');
        }
    };



    return (
        <section className="blog_details_section section_space bg-light">
            <div className="container">
                <div className="blog_post_block content_over_layout">
                    <div className="blog_post_image">
                        <Link onClick={ClickHandler} to={`/blog-single/${BlogDetails.slug}`} className="image_wrap">
                            <img src={BlogDetails.headerImage} alt="Blog Post" loading="lazy" />
                        </Link>
                    </div>
                    <div className="blog_post_content p20">
                        <div className="post_meta_wrap gap20">
                            <ul className="category_btns_group unordered_list">
                                <li><Link onClick={ClickHandler} to={`/blog-single/${BlogDetails.slug}`}>{BlogDetails.thumb}</Link></li>

                            </ul>
                            <ul className="post_meta unordered_list">
                                <li>
                                    <Link onClick={ClickHandler} to={`/blog-single/${BlogDetails.slug}`}>
                                        <i className="fa-regular fa-calendar-days"></i> {BlogDetails.create_at}
                                    </Link>
                                </li>


                            </ul>
                        </div>
                        <h3 className="blog_post_title">
                            <Link onClick={ClickHandler} to={`/blog-single/${BlogDetails.slug}`}>
                                {BlogDetails.title}
                            </Link>
                        </h3>
                        <p className="mb-0">
                            {BlogDetails.description}
                        </p>
                    </div>
                </div>

                <h2 className="details_item_title">
                    {BlogDetails.title}
                </h2>
                <p className='details_item_info_heading_p detail_des'>
                    {BlogDetails.DetailDescription}
                </p>
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <ul className="post_meta unordered_list">
                            <li>
                                <Link >
                                    <img src={icon2} alt="Icon User" loading="lazy" /> by {BlogDetails.author}
                                </Link>
                            </li>
                            {/* <li>
                                <Link onClick={ClickHandler} to={'/blog'}>
                                    <img src={icon3} alt="Icon Chat" /> {BlogDetails.comment} Comments
                                </Link>
                            </li> */}
                            {/* <li>
                                <Link onClick={ClickHandler} to={'/blog'}>
                                    <img src={icon4} alt="Icon Eye" /> 20k Views
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <ul className="post_meta unordered_list justify-content-md-end">
                            <li>
                                <button type="button" onClick={handleCopyLink} style={{background:'none',border:'none',padding:0,cursor:'pointer',display:'inline-flex',alignItems:'center'}}>
                                    <img src={icon5} alt="Icon Link" loading="lazy" /> Copy Link
                                </button>
                            </li>
                            <li>
                                <button type="button" onClick={handleBookmark} style={{background:'none',border:'none',padding:0,cursor:'pointer',display:'inline-flex',alignItems:'center'}}>
                                    <img src={icon6} alt="Bookmark" loading="lazy" />
                                    {isBookmarked ? ' Bookmarked' : ' Bookmark'}
                                </button>
                            </li>

                        </ul>
                    </div>

                </div>
                <hr className="mb-0" />
                <div className="section_space pb-0">
                    <div className="row">
                        <div className="col-lg-8">


                            <h3 className="details_item_info_title mb-5">
                                {BlogDetails.details_item_info_title}
                            </h3>
                            <div className="row mb-4">
                                <div className="col-md-6 col-sm-6 pic-dis-none">
                                    <div className="details_item_image m-0 p-2 bg-white rounded-3 shadow-sm">
                                        <img src={BlogDetails.innerImage1} alt="Techco - Blog" className="img-fluid rounded-3" loading="lazy" />
                                    </div>

                                </div>
                                <div className="col-md-6 col-sm-6">
                                    <div className="details_item_image m-0 p-2 bg-white rounded-3 shadow-sm">
                                        <img src={BlogDetails.innerImage2} alt="Techco - Blog" className="img-fluid rounded-3" loading="lazy" />
                                    </div>

                                </div>
                            </div>
                            <div className="card p-4 rounded-4 shadow-sm mb-4 bgcolor">
                                <p className="mb-0 text-dark detail_des">
                                    {BlogDetails.details_item_info_description}
                                </p>
                            </div>


                            <h3 className="details_item_info_title details_item_info_heading_p">{BlogDetails.sampleHead}</h3>
                            <div className="card bg-white border-start p-4 rounded-4 shadow-sm mb-4">
                                <p className="mb-0 detail_des">
                                    {BlogDetails.summary}
                                </p>
                            </div>
                            <div className="row align-items-start mb-5"> {/* changed from align-items-center to align-items-start */}
                                <div className="col-md-6 mb-4 mb-md-0">
                                    <div className="details_item_image">
                                        <img
                                            src={BlogDetails.samheading}
                                            alt="Techco - Blog"
                                            className="img-fluid rounded-4 shadow"
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <ul className="unordered_list_block list-unstyled">
                                        {BlogDetails.sampleHeadings.map((heading, index) => (
                                            <li
                                                key={index}
                                                className="card p-3 mb-3"
                                                style={{
                                                    fontSize: "1rem",
                                                    lineHeight: "1.5",
                                                    color: "#333",
                                                    borderRadius: "0.5rem",
                                                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)"
                                                }}
                                            >
                                                <div className="d-flex align-items-start">

                                                    <span style={{ flex: 1 }}>{heading}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <Suspense fallback={<div>Loading sidebar...</div>}>
                            <BlogSidebar />
                        </Suspense>
                    </div>


                    <p className="mb-2">
                        <h3 className="details_item_info_title">Reasons to investing at this moment</h3>
                        Here are the key reasons emphasizing the importance of optimizing IT infrastructure for efficiency and growth:
                    </p>
                    <div
                        className="icon_list unordered_list_block mb-5"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)', // two equal columns
                            gap: '1rem',
                        }}
                    >
                        {BlogDetails.reasonsToInvestNow.map((heading, index) => (
                            <div
                                key={index}
                                style={{ width: '100%' }} // full width of grid column
                            >
                                <div className="p-3 bg-light border-start border-success border-3 rounded shadow-sm d-flex align-items-start gap-2">
                                    <i className="fa-solid fa-circle fa-fw text-success mt-1"></i>
                                    <span className="text-dark">{heading}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr className="mt-0 mb-5" />
                    <div className="row">
                        <div className="col-md-6">
                            <ul className="tags_list unordered_list">
                                <li><Link  >{BlogDetails.solution}</Link></li>
                                <li><Link  >{BlogDetails.consultant}</Link></li>
                                <li><Link  >{BlogDetails.it}</Link></li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <div className="post_share_link">
                                <ul className="social_icons_block unordered_list justify-content-md-end">
                                    {/* <li>
                                                <Link onClick={ClickHandler} to={'/blog'} className="rounded-circle">
                                                    <img src={sImg1} alt="Icon Facebook" />
                                                </Link>
                                            </li> */}
                                    <li>
                                        <Link to="https://www.instagram.com/laskon_technologies?igsh=aHZ2Z3lib293MHhh&utm_source=qr" className="rounded-circle">
                                            <i className="fa-brands fa-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/laskon_tech?s=11&t=rTiTfARWKLzRDbxPxcnpWA" className="rounded-circle">
                                            <i className="fa-brands fa-twitter"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.linkedin.com/company/laskon-technologies/" className="rounded-circle">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="post_author_box">
                    <div className="author_image">
                        <img src={BlogDetails.authorImage} alt="Techco - Blog Author" loading="lazy" />
                    </div>
                    <div className="author_content">
                        <h3 className="author_name">{BlogDetails.author}</h3>
                        <h4 className="author_designation">{BlogDetails.authorTitle}</h4>
                        <p>
                            {BlogDetails.editor}
                        </p>

                    </div>
                </div>
                <div className="comment_area mb-0" style={{'display':'none'}}>
                    <h3 className="details_item_info_title mb-1">Leave a Comment</h3>
                    <p className="mb-5">
                        Your email address will not be published. Required fields are marked <sup className="text-primary">*</sup>
                    </p>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="input_title" htmlFor="input_name">Full Name <sup className="text-primary">*</sup></label>
                                <input id="input_name" className="form-control" type="text" name="name" placeholder="Goladra Gomaz" required />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="input_title" htmlFor="input_email">Your Email <sup className="text-primary">*</sup></label>
                                <input id="input_email" className="form-control" type="email" name="email" placeholder="Techco@example.com" required />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <label className="input_title" htmlFor="input_textarea">Comments / Questions <sup className="text-primary">*</sup></label>
                                <textarea id="input_textarea" className="form-control" name="message" placeholder="How can we help you?"></textarea>
                            </div>
                            {/* <div className="form-check mb-5">
                                <input className="form-check-input" type="checkbox" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Save my name, email, and website in this browser for the next time I comment.
                                </label>
                            </div> */}
                            <button type="submit" className="btn btn-primary">
                                <span className="btn_label" data-text="Submit Comment">Submit Comment</span>
                                <span className="btn_icon">
                                    <i className="fa-solid fa-arrow-up-right"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default BlogSingle;
